const baseName = process.env.REACT_APP_BASE_NAME;

export default baseName;
